import React, { useReducer } from 'react'
import ProductReducer from './productReducer'
import ProductContext from './productContext'
import { apiCall } from '@/product/common/api'
import { response } from '@/product/context/common'

import {
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_PROJECT_COMMENTS,
    GET_FETCH_DATA,
} from './productTypes'

const ProductState = (props) => {
    const initialState = {
        project_comments: {},
        responseStatus: {},
        search_fetch_data: {
            records: [],
            totalRecords: 0,
            setDisp: '',
            sorts: {},
        },
    }

    const [state, dispatch] = useReducer(ProductReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getProjectComments = async (formData, fromVariable) => {
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'commentsList',
                    formData,
                    '',
                    `custom/product`,
                    '',
                    '',
                    true
                ),
            ])
            const from = fromVariable ? fromVariable : 'getProjectComments'
            if (res.data.status === 'success') {
                console.log(
                    res.data.data.responseData,
                    'res.data.data.responseData.records'
                )
                dispatch({
                    type: GET_PROJECT_COMMENTS,
                    payload: {
                        records: res.data.data.responseData.data
                            ? res.data.data.responseData.data
                            : [],

                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const searchTableFetch = async (formData, fromVariable) => {
        const from = fromVariable || 'searchTableFetch'
        try {
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'searchTableFetch',
                    formData,
                    '',
                    `custom/product`,
                    '',
                    '',
                    true
                ),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_FETCH_DATA,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        sorts: res.data.data.responseData?.sorts || {},
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const searchTableAction = async (formData, noAlert = false, from) => {
        try {
            from = from ? from : 'CommunicationSearchTable'
            const [res] = await Promise.all([
                apiCall(
                    'post',
                    'searchTableAction',
                    formData,
                    '',
                    `custom/product`,
                    '',
                    '',
                    true
                ),
            ])
            resp.commonResponse(res.data, from, noAlert)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <ProductContext.Provider
            value={{
                responseStatus: state.responseStatus,
                project_comments: state.project_comments,
                search_fetch_data: state.search_fetch_data,
                searchTableFetch,
                searchTableAction,
                getProjectComments,
                clearResponse,
            }}
        >
            {props.children}
        </ProductContext.Provider>
    )
}

export default ProductState
